import React from 'react';
import { useLayoutState } from 'components/shared/Layout';
import NeedHelp from 'components/layout/Footer/NeedHelp';
import Sitemap from 'components/layout/Footer/Sitemap';
import Copyright from 'components/layout/Footer/Copyright';
import Cookies from 'components/layout/Footer/Cookies';

const Footer = ({ pageIdentifier, ssrRender }) => {
  const { layoutState } = useLayoutState();
  return (
    <footer>

      <NeedHelp pageIdentifier={pageIdentifier} />
      <Sitemap />
      <Copyright />

      {layoutState?.settings
        && !ssrRender && layoutState.settings.show_cookie_notification && <Cookies />}
    </footer>
  );
};

export default React.memo(Footer);
